// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1p44c","col":"styles_col__14giR"};